<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    class="layout--main"
    :class="[layoutTypeClass, navbarClasses, footerClasses, {'no-scroll': isAppPage}]"
  >
    <v-nav-menu
      title="MAXAIN"
      parent=".layout--main"/>

    <div id="content-area" :class="[contentAreaClass, {'show-overlay': bodyOverlay}]">
      <div id="content-overlay"/>

      <!-- Navbar -->
      <!--<template v-if="mainLayoutType === 'horizontal' && windowWidth >= 1200">
        <the-navbar-horizontal
          :navbarType="navbarType"
          :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]"/>

        <div style=" height: 62px" v-if="navbarType === 'static'"></div>

        <h-nav-menu
          :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]"
          :navMenuItems="navMenuItems"/>
      </template>-->

<!--      <template v-else>-->
        <the-navbar-vertical
          :navbarColor="navbarColor"

          @send-overview-info="sendOverviewInfo"
          :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]"/>
<!--      </template>-->
<!--       /Navbar -->

      <div class="content-wrapper" id="contentwrapper">

        <div class="router-view" id="routerview">
          <div class="router-content">

            <transition :name="routerTransition">

              <div
                v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
                   class="router-header flex flex-wrap items-center mb-6">
                <div
                  class="content-area__heading"
                  :class="{'pr-4 border-0 md:border-r border-solid border-grey-light' : $route.meta.breadcrumb}">
                  <h2 class="mb-1">{{ routeTitle }}</h2>
                </div>

                <!-- BREADCRUMB -->
                <vx-breadcrumb class="ml-4 md:block hidden" v-if="$route.meta.breadcrumb" :route="$route"
                               :isRTL="$vs.rtl"/>

              </div>
            </transition>

            <div class="content-area__content">

              <back-to-top bottom="10%" :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'" visibleoffset="500"
                           v-if="!hideScrollToTop && !hideBackToTop">
                <div class="back-to-top-outer-box">
                  <i class="el-icon-top"></i>
                </div>
              </back-to-top>

              <transition :name="routerTransition" mode="out-in">
                <router-view
                  @changeRouteTitle="changeRouteTitle"
                  @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)"
                  :overview-info="overviewInfo"
                />
              </transition>
            </div>
          </div>
        </div>
      </div>
      <the-footer/>
    </div>
  </div>
</template>


<script>
  import {queryAccountLimit} from "@/api/userCenter";
  import { mapGetters } from 'vuex'
  import BackToTop from 'vue-backtotop'
  import TheNavbarHorizontal from '@/layouts/components/navbar/TheNavbarHorizontal.vue'
  import TheNavbarVertical from '@/layouts/components/navbar/TheNavbarVertical.vue'
  import TheFooter from '@/layouts/components/TheFooter.vue'
  import themeConfig from '@/../themeConfig.js'
  import VNavMenu from '@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue';

  export default {
    components: {
      BackToTop,
      TheFooter,
      TheNavbarVertical,
      VNavMenu,
    },
    data() {
      return {
        footerType: themeConfig.footerType || 'static',
        hideScrollToTop: themeConfig.hideScrollToTop,
        isNavbarDark: false,
        navbarColor: themeConfig.navbarColor || '#fff',
        navbarType: themeConfig.navbarType || 'floating',
        routerTransition: themeConfig.routerTransition || 'none',
        routeTitle: this.$route.meta.pageTitle,
        overviewInfo: {}

      }
    },
    created() {
      if(localStorage.getItem('userInfo') ){
        this.$store.commit('setUserInfo', JSON.parse(localStorage.getItem('userInfo')));
      }

      if(localStorage.getItem('agentRole')){
        this.$store.commit('setAgentRole',localStorage.getItem('agentRole'));
      }
      const color = this.navbarColor == "#fff" && this.isThemeDark ? "#10163a" : this.navbarColor;
      this.updateNavbarColor(color);
      this.setNavMenuVisibility(this.$store.getters.mainLayoutType);
      this.queryIntegralFeature();
    },
    watch: {
      "$route"() {
        this.routeTitle = this.$route.meta.pageTitle
      },
      isThemeDark(val) {
        const color = this.navbarColor == "#fff" && val ? "#10163a" : "#fff"
        this.updateNavbarColor(color)
      },
      "$store.getters.mainLayoutType"(val) {
        this.setNavMenuVisibility(val)
      }
    },
    computed: {
      ...mapGetters(['userInfo', 'hideBackToTop']),

      bodyOverlay() {
        return this.$store.getters.bodyOverlay
      },
      contentAreaClass() {
        if (this.mainLayoutType === "vertical") {
          if (this.verticalNavMenuWidth == "default") return "content-area-reduced"
          else if (this.verticalNavMenuWidth == "reduced") return "content-area-lg"
          else return "content-area-full"
        }
        // else if(this.mainLayoutType === "boxed") return "content-area-reduced"
        else return "content-area-full"
      },
      footerClasses() {
        return {
          'footer-hidden': this.footerType == 'hidden',
          'footer-sticky': this.footerType == 'sticky',
          'footer-static': this.footerType == 'static',
        }
      },
      isAppPage() {
        return this.$route.meta.no_scroll
      },
      isThemeDark() {
        return this.$store.getters.theme == 'dark'
      },
      layoutTypeClass() {
        return `main-${this.mainLayoutType}`
      },
      mainLayoutType() {
        return this.$store.getters.mainLayoutType
      },
      navbarClasses() {
        return {
          'navbar-hidden': this.navbarType == 'hidden',
          'navbar-sticky': this.navbarType == 'sticky',
          'navbar-static': this.navbarType == 'static',
          'navbar-floating': this.navbarType == 'floating',
        }
      },
      verticalNavMenuWidth() {
        return this.$store.getters.verticalNavMenuWidth
      },
      windowWidth() {
        return this.$store.getters.windowWidth
      },

    },
    methods: {
      queryIntegralFeature(){
        queryAccountLimit({
          custId: this.userInfo.id,
        }).then((res) => {
          this.$store.commit('setIntegralFeatureFlag',res.data.rewardPointFlag)
          this.$store.commit('setExternalTransferFlag',res.data.externalTransferFlag)
        })
      },
      changeRouteTitle(title) {
        this.routeTitle = title
      },
      updateNavbar(val) {
        if (val == "static") this.updateNavbarColor(this.isThemeDark ? "#10163a" : "#fff")
        this.navbarType = val
      },
      updateNavbarColor(val) {
        this.navbarColor = val
        if (val == "#fff") this.isNavbarDark = false
        else this.isNavbarDark = true
      },
      updateFooter(val) {
        this.footerType = val
      },
      setNavMenuVisibility(layoutType) {
        if ((layoutType === 'horizontal' && this.windowWidth >= 1200) || (layoutType === "vertical" && this.windowWidth < 1200)) {
          this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
          this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')
        } else {
          this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
        }
      },
      toggleHideScrollToTop(val) {
        this.hideScrollToTop = val
      },
      sendOverviewInfo(overviewInfo){
        this.overviewInfo = overviewInfo;
      }
    },
  }

</script>
<style lang="scss">
@import "../../assets/scss/variable";
//一短一长的下列选择框 拼在以前
.query-header {
  .short-select .el-input__inner {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .long-select .el-input__inner {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}

.back-to-top-outer-box {
  background-color: $themeColor;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .el-icon-top {
    font-size: 20px;
  }
}
// 这个是最高层级 el-message-box 的父元素
.el-message-box__wrapper {
  z-index: 99999!important;
}

// 移动端样式
@media screen and (max-width: 768px){
  .el-dialog,
  .el-message-box {
    width: 90%!important;
  }
  .app-wrapper {
    .copy-footer-outer {
      padding-right: 0;
    }
  }
}
// pc端样式
@media screen and (min-width: 768px){
  .pc-padding30-mobil-padding20 {
    padding: 30px;
  }
  .pc-margin-bottom30-mobil-margin-bottom20 {
    margin-bottom: 30px;
  }
  .padding30 {
    padding: 30px;
  }
  .total-data {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
.app-wrapper {

  &.mobile.openSidebar {
    position: fixed;
    top: 0;

    .copy-footer {
      padding-left: 20px;
    }
  }
  &.hideSidebar {
    .copy-footer {
      padding-right: 30px;
    }
  }
}

.rule-table-outer {
  overflow-x: auto;
  overflow-y: hidden;
  .rule-table {
    min-width: 900px;
  }
}
</style>
